import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getApiUrl } from '../config/api';
import './AuthPages.css';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const userId = searchParams.get('userId');
    const token = searchParams.get('token');

    if (!userId || !token) {
      setErrorMessage('Invalid verification link. Please check your email and try again.');
      setStatus('error');
      return;
    }

    const verify = async () => {
      try {
        const response = await fetch(
          getApiUrl(`/api/auth/verify-email?userId=${encodeURIComponent(userId)}&token=${encodeURIComponent(token)}`),
          { method: 'POST' }
        );

        let data;
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          data = await response.json();
        }

        if (response.ok) {
          setStatus('success');
        } else {
          const msg = data?.message || data?.errors?.[0] || 'Email verification failed. The link may have expired.';
          setErrorMessage(msg);
          setStatus('error');
        }
      } catch {
        setErrorMessage('Unable to connect to the server. Please try again later.');
        setStatus('error');
      }
    };

    verify();
  }, [searchParams]);

  if (status === 'verifying') {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>Verifying Your Email...</h1>
          <p className="auth-subtitle">Please wait while we confirm your email address.</p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>Email Verified!</h1>
          <p className="auth-subtitle">Your email address has been confirmed successfully.</p>
          <div className="auth-success" style={{
            padding: '16px',
            backgroundColor: '#d1fae5',
            color: '#065f46',
            borderRadius: '8px',
            marginTop: '24px',
            marginBottom: '24px'
          }}>
            Your account is now active. You can sign in and start using MyDocAI.
          </div>
          <Link to="/login" className="auth-button" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
            Sign In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Verification Failed</h1>
        <p className="auth-subtitle">We couldn't verify your email address.</p>
        <div className="auth-error" style={{ marginTop: '20px' }}>
          {errorMessage}
        </div>
        <div className="auth-footer" style={{ marginTop: '30px' }}>
          <p>
            Need a new verification link?{' '}
            <Link to="/login">Go to login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
